"use client";
import React, {useEffect, useState} from "react";
import LoadingGame from "./LoadingGameText";


export const GameLoadingModal = ({
                                     thumbnail,
                                     mode
                                 }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => (prev < 100 ? prev + 1 : 100));
        }, 80);

        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <>
            <div
                className={`h-[100dvh] left-0 flex flex-col relative ${mode === "dark" ? "bg-black" : "bg-white"} transform transition-all duration-200 ease-out w-full items-center justify-center rounded-none overflow-hidden`}
            >
                {/* Image wrapper */}
                <div className="absolute inset-0">
                    <img
                        draggable="false"
                        src={thumbnail}
                        alt="Background"
                        className="w-full h-[25%] object-cover"
                        style={{
                            filter: "blur(2px)",
                        }}
                    />
                </div>

                <div
                    className="z-10 flex items-center justify-center"
                    style={{
                        borderRadius: 20,
                    }}
                >
                    <div
                        style={{borderRadius: "10px"}}
                        className="multiplayer-modal-wrapper"
                    >
                        <div
                            className="flex flex-col gap-6 justify-center items-center pb-14 pt-2 md-lg:translate-y-5 lg:-translate-y-6">
                            <div className="h-36 w-36 border-[10px] border-[#282828] rounded-[15px]">
                                <img
                                    draggable="false"
                                    src={thumbnail}
                                    alt="game-logo-icon"
                                    className="h-full w-full object-cover rounded-[5px]"
                                />
                            </div>
                            <div className="w-full max-w-sm mt-4">
                                <div className={`w-full ${mode === "dark" ? "bg-gray-700" : "bg-gray-300"}   h-2 rounded-full overflow-hidden`}>
                                    <div
                                        className={`${mode === "dark" ? "bg-white" : "bg-black"} h-full transition-all duration-100`}
                                        style={{width: `${progress}%`}}
                                    ></div>
                                </div>
                            </div>
                            <LoadingGame mode={mode}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
